// Shopify frontend development: Swiper.js implementation for the Reviews Slider section.

// Use a self-executing function to avoid global scope pollution
(() => {
  // Check for Swiper availability (it's loaded via unpkg link in the liquid file)
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper library is not loaded. Ensure the Swiper bundle link is present in the liquid file.');
    return;
  }

  // Function to initialize all review sliders on the page
  function initReviewsSliders() {
    const sliderSections = document.querySelectorAll('.reviews-slider-section');

    sliderSections.forEach(section => {
      const sectionId = section.dataset.sectionId;
      const swiperContainer = section.querySelector('.swiper-container');

      if (!swiperContainer) return;

      const spaceBetweenDesktop = parseInt(section.dataset.spaceBetweenDesktop);
      const spaceBetweenMobile = parseInt(section.dataset.spaceBetweenMobile);
      const slidesPerViewDesktop = Math.max(3, parseInt(section.dataset.slidesPerViewDesktop) || 3);
      // Offset is handled via CSS padding on the container, but values are available if needed for advanced Swiper options.

      // Destroy existing Swiper instance to prevent re-initialization issues in Customizer
      if (swiperContainer.swiper) {
        swiperContainer.swiper.destroy(true, true);
      }

      const equalHeightEnabled = swiperContainer.classList.contains('reviews-slider__container--equal-height');
      
      const swiper = new Swiper(swiperContainer, {
        loop: true,
        grabCursor: true,
        slidesPerView: 1.1,
        centeredSlides: false, 
        spaceBetween: 15,
        autoHeight: equalHeightEnabled ? false : false,
        breakpoints: {
          500: {
            slidesPerView: 2,
            spaceBetween: spaceBetweenDesktop,
          },
          1100: {
            slidesPerView: slidesPerViewDesktop,
            spaceBetween: spaceBetweenDesktop,
          },
          1400: {
            slidesPerView: slidesPerViewDesktop, 
            spaceBetween: spaceBetweenDesktop,
          },
        },
        on: {
          init: function() {
            if (equalHeightEnabled) {
              this.updateAutoHeight();
            }
          },
          slideChange: function() {
            if (equalHeightEnabled) {
              this.updateAutoHeight();
            }
          }
        }
      });
      
      if (equalHeightEnabled) {
        function setEqualHeight() {
          const slides = swiperContainer.querySelectorAll('.swiper-slide');
          let maxHeight = 0;
          
          slides.forEach(slide => {
            const slideContent = slide.querySelector('.review-slide');
            if (slideContent) {
              slideContent.style.height = 'auto';
              const height = slideContent.offsetHeight;
              if (height > maxHeight) {
                maxHeight = height;
              }
            }
          });
          
          slides.forEach(slide => {
            const slideContent = slide.querySelector('.review-slide');
            if (slideContent) {
              slideContent.style.height = maxHeight + 'px';
            }
          });
        }
        
        setEqualHeight();
        window.addEventListener('resize', setEqualHeight);
      }

      // Customizer Integration (Theme Editor)
      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          if (event.detail.sectionId === sectionId) {
            // Find the index of the selected block
            const slideIndex = Array.from(swiperContainer.querySelectorAll('.swiper-slide')).indexOf(event.target);
            // Slide to the selected block
            if (slideIndex > -1) {
              // Using speed: 0 ensures instant transition in the editor
              swiper.slideTo(slideIndex, 0);
            }
          }
        });
      }
    });
  }

  // Initialize on DOM load and re-initialize on window load/resize 
  document.addEventListener('DOMContentLoaded', initReviewsSliders);
  window.addEventListener('load', initReviewsSliders);
})();